import PropTypes from 'prop-types';
import React from 'react';
import { buildRowActions } from '../utils/rowActions';

// The per-event action buttons: a labeled "Event details" button followed by
// three icon-only buttons. Shared by the desktop row-hover group (TicketsTable)
// and the mobile card action row (MobileEventList).
function RowActionButtons({ team, event }) {
  return (
    <>
      {buildRowActions(team, event).map((action) => (
        action.key === 'details' ? (
          <a
            key={action.key}
            href={action.href}
            className="tickets-icon-btn tickets-event-action-labeled"
          >
            <action.Icon />
            <span>{action.label}</span>
          </a>
        ) : (
          <a
            key={action.key}
            href={action.href}
            className="tickets-icon-btn tickets-has-tip"
            data-tip={action.tip}
            aria-label={action.label}
          >
            <action.Icon />
          </a>
        )
      ))}
    </>
  );
}

RowActionButtons.propTypes = {
  team: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired }).isRequired,
  event: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired }).isRequired,
};

export default RowActionButtons;
